import React from 'react';

type Props = {
  title: string;
};

const TagLesson: React.FC<Props> = ({ title }) => {
  return (
    <div className="bg-tag text-white rounded-[6px] px-2 h-[22px] flex items-center justify-center">
      <p className="text-tiny font-normal">{title}</p>
    </div>
  );
};

export default TagLesson;
